import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetRecommendedPriceSellerUseCase extends UseCase {
  constructor({httpRepository, rawParamsToGetRecommendedPriceRequestMapper}) {
    super()

    this._httpRepository = httpRepository
    this._rawParamsToGetRecommendedPriceRequestMapper = rawParamsToGetRecommendedPriceRequestMapper
  }

  @tracer({metric: 'GetRecommendedPriceSellerUseCase#execute'})
  @inlineError
  execute({...rawParams}) {
    const recommendedPriceRequest = this._rawParamsToGetRecommendedPriceRequestMapper.map(rawParams)

    return this._httpRepository
      .getRecommendedPrice({
        recommendedPriceRequest
      })
      .then(async ([error, recommendedPriceVO]) => {
        if (error) return Promise.reject(error)

        return recommendedPriceVO.toJSON()
      })
  }
}
